<template>
  <b-modal :active="value" has-modal-card full-screen @close="close()">
    <!-- 患者選択 -->
    <form style="width: 90%; height: 30px; margin-left: 5%; margin-top: 1%">
      <div class="modal-card" style="width: 100%">
        <section class="modal-card-body" style="width: 100%; height: 100%">
          <div class="box" style="margin-left: 50px; margin-right: 50px">
            <div class="columns">
              <div class="column">
                <label class="searchTitle label">得意先一覧</label>
              </div>
            </div>

            <!-- 検索 -->
            <template :searchConditions="searchConditions">
              <div class="columns">
                <div class="column">
                  <div class="field box is-floating-label">
                    <label class="label">絞込条件</label>
                    <div class="columns">
                      <div v-if="useOfficeCode" class="column is-one-fourth">
                        <b-field label="営業所コード" labelPosition="on-border">
                          <b-input v-model="searchConditions.officeCode"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-one-fourth">
                        <b-field label="得意先コード" labelPosition="on-border">
                          <b-input v-model="searchConditions.code"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-one-fourth">
                        <b-field label="得意先名" labelPosition="on-border">
                          <b-input v-model="searchConditions.name"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-one-fourth">
                        <b-field label="郵便番号" labelPosition="on-border">
                        <b-input v-model="searchConditions.postCode"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-one-fourth">
                        <b-field label="電話番号" labelPosition="on-border">
                          <b-input
                            v-model="searchConditions.phoneNumber"
                            type="text"
                            maxlength="20"
                          ></b-input>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column is-one-fourth">
                        <b-field
                          label="区分"
                          labelPosition="on-border"
                          class="checkboxButtonField"
                          v-if="divisionDisplay"
                        >
                          <b-checkbox-button 
                            v-model="division" 
                            native-value=customer.patient.code
                            >{{customer.patient.name}}</b-checkbox-button
                          >
                          <b-checkbox-button 
                            v-model="division" 
                            native-value=customer.hospital.code
                            >{{customer.hospital.name}}</b-checkbox-button
                          >
                        </b-field>
                      </div>
                      <div class="column">
                        <span style="color: red" v-if="isSearchConditionNull"
                          >検索条件を指定してください。</span
                        >
                        <span style="color: red" v-if="isSearchConditionAll"
                          >全件検索となる為、検索条件を絞り込んでください。</span
                        >
                        <b-button
                          style="float: right"
                          class="button"
                          type="is-primary"
                          icon-right="filter"
                          native-type="button"
                          @click="search()"
                          >検索</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- 検索結果 -->
            <div class="columns">
              <div class="column">
                <b-field
                  horizontal
                  label="表示件数"
                  style="float: right; white-space: nowrap"
                >
                  <b-select position="is-right" v-model="perPage">
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                  </b-select>
                </b-field>
              </div>
            </div>
            <div>
              <b-table
                :data="data"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :pagination-size="paginationSize"
                :default-sort-direction="defaultSortDirection"
                default-sort="name"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
              >
                <template slot-scope="props">
                  <b-table-column field="patientCode" label sortable centered>
                    <b-radio
                      v-model="selected"
                      :native-value="props.row"
                    ></b-radio>
                  </b-table-column>
                  <b-table-column
                    field="code"
                    label="得意先コード"
                    sortable
                    centered
                  >
                    {{ props.row.code }}
                  </b-table-column>
                  <b-table-column field="name" label="得意先名" sortable>
                    {{ props.row.name }}
                  </b-table-column>
                  <b-table-column field="division" label="区分" sortable centered>
                    {{ props.row.division }}
                  </b-table-column>
                  <b-table-column field="postCode" label="郵便番号" sortable>
                    {{ props.row.postCode }}
                  </b-table-column>
                  <b-table-column field="address" label="住所" sortable>
                    {{ props.row.address }}
                  </b-table-column>
                  <b-table-column field="phoneNumber" label="電話番号" sortable>
                    {{ props.row.phoneNumber }}
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </section>

        <footer style="text-align: center">
          <b-button
            v-on:click="close()"
            class="button"
            type="is-primary"
            icon-left="keyboard-backspace"
            native-type="button"
          >
            戻る
          </b-button>
          <b-button
          v-on:click="showAddPatientInfo()"
            class="button"
            type="is-primary"
            icon-left="content-save"
            native-type="button"
          >
            選択
          </b-button>
          <div style="height: 10px" />
        </footer>

        <!-- 追加情報ダイアログ -->
      <add-patient-info-modal
        v-if="isShowAddPatientInfo"
        v-on:add-patient="addPatientList"
        v-model="isShowAddPatientInfo"
        v-bind:patient-info="selected"
      />
      </div>
    </form>
  </b-modal>
</template>

<script>
import addPatientInfoTemplate from "../common/AddPatientInfo";
import * as customer from "../../utils/customer";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    fixedDivision: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    useOfficeCode: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    "add-patient-info-modal": addPatientInfoTemplate,
  },

  data() {
    var data = [];
    let officeCode;
    if (this.useOfficeCode) {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      officeCode = userInfo.officeCode;      
    }

    return {
      data,
      searchConditions: {
        officeCode: officeCode,
        code: "",
        name: "",
        postCode: "",
        phoneNumber: "",
        division: "",
      },
      selected: "",
      division: [],
      isSearchConditionNull: false,
      isSearchConditionAll: false,
      // ページ
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 100,

      template: {
        recipientCode: "",
        recipientName: "",
        recipientNameKana: "",
        phoneNumber: "",
        emergencyLevelCode: "",
        staffCode: "",
        staffName: "",
        officeCode: "",
        officeName: "",
        status: "",
        supportKind: "",
        postCode: "",
        address: "",
        productDetail: [
          {
            productName: "",
            productCode: "",
            serialNumber: "",
            hospitalName: "",
            hospitalCode: "",
          },
        ],
        disasterSupport: {
          content: "",
          result: "",
        },
      },
      isShowAddPatientInfo: false,
      customer: customer.CUSTOMER_TYPE_MAP,
    };
  },

  computed: {
    divisionDisplay: function() {
      let display = true;
      if (this.fixedDivision){
        display = false;
      }

      return display;
    },
  },

  filters: {},

  methods: {
    addPatientList: function (info) {
      this.$emit("add-patient", info);
      this.close();
    },

    close: function () {
      this.$emit("input", false);
      return;
    },

    search: function () {
      if (
        this.searchConditions.officeCode ||
        this.searchConditions.code ||
        this.searchConditions.name ||
        this.searchConditions.postCode ||
        this.searchConditions.phoneNumber ||
        this.division.length > 0
      ) {
        // 検索条件あり
        this.isSearchConditionNull = false;
        if (
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.code) &&
          !this.isLength(this.searchConditions.name) &&
          !this.isLength(this.searchConditions.postCode) &&
          !this.isLength(this.searchConditions.phoneNumber)
        ) {
          this.isSearchConditionAll = true;
          return;
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.fixedDivision) {
          this.searchConditions.division = this.fixedDivision;
        } else {
          if (this.division.length == 1) {
            this.searchConditions.division = this.division[0];
          } else {
            this.searchConditions.division = "";
          }
        }
        // 検索実行
        var excuteApi = this.getCustomerListPOST;
        var successCallBack = this.getCustomerListSuccess;
        var errorCallBack = this.getCustomerListError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        // 検索条件未入力
        this.isSearchConditionAll = false;
        this.isSearchConditionNull = true;
      }
    },

    getCustomerListPOST: function (client) {
      return client.apis.apiMaster.getCustomerListPOST({
        body: {
          officeCode: this.searchConditions.officeCode,
          code: this.searchConditions.code,
          name: this.searchConditions.name,
          division: this.searchConditions.division,
          postCode: this.searchConditions.postCode,
          phoneNumber: this.searchConditions.phoneNumber,
        },
      });
    },
    getCustomerListSuccess: function (result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getCustomerListError: function (result) {
      this.showErrorMessage(result);
    },

    showAddPatientInfo: function () {
      // ユーザを選んでない場合、エラーメッセージ
      if (!this.selected) {
        this.showErrorMessage(
          "得意先を選択してください",
        );
        return;
      }

      if (this.returnObject) {
        this.$emit("set-hospital", this.selected);
        this.close();
      } else {
        this.isShowAddPatientInfo = true;
      }
    },
  },

  mounted: function () {
    // WebApi Call
    if (this.isSearchConditionNull) {
      this.search(this.searchConditions);
    }
  },

  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/SelectPatientForCustomerList.vue